import React, { useEffect } from 'react'
import _ from 'lodash'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { getValue, option } from '../../../../../../../lib/common'
import { shallowEqual, useSelector } from 'react-redux'
import clsx from 'clsx'
import { isSame } from '../../../../isSame'
import { Map } from 'immutable'

export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id, sortList },
  rows,
  uid,
  setPage,
  setFilterCols,
  path,
}) {
  const colFilter = useSelector((state) => state.getIn(['filter', ...path, 'cols'], Map()), isSame)
  let { size, variant } = useSelector((state) => {
    return {
      size: state.getIn(
        ['project', 'Settings', 'theme', 'lg', 'PowerTableFilterField', 'all', 'sizeVariant'],
        state.getIn(['project', 'Settings', 'theme', 'lg', 'PowerTableFilterField', 'root', 'sizeVariant'], '')
      ),
      variant: state.getIn(
        ['project', 'Settings', 'theme', 'lg', 'PowerTableFilterField', 'all', 'textVariant'],
        state.getIn(['project', 'Settings', 'theme', 'lg', 'PowerTableFilterField', 'root', 'textVariant'], 'standard')
      ),
    }
  }, shallowEqual)
  let originVariant = variant
  if (variant === 'classic') {
    variant = 'outlined'
  }
  if (['standard', 'filled', 'outlined'].indexOf(variant) === -1) {
    variant = 'standard'
  }
  let notchedOutlineClass = ''
  let containerClass = ''
  if (originVariant == 'classic') {
    notchedOutlineClass = ' ftnotchedOutline-classic'
    containerClass += 'ft--theme--FormField--ftclassic'
  }

  if (!['medium', 'small'].includes(size)) {
    size = 'medium'
  }
  if (size != 'medium') {
    containerClass += 'fix-label-padding-small '
  } else {
    containerClass = 'fix-label-padding '
  }

  // Calculate the options for filtering
  // using the preFilteredRows
  const options = React.useMemo(() => {
    let options = []
    if (rows.length === 0) {
      if (filterValue) {
        return [option(filterValue, filterValue)]
      } else {
        return options
      }
    }
    preFilteredRows.forEach((row) => {
      options.push(option(row.values[id], row.values[id]))
      // options.add(row.values[id])
    })
    options = _.uniqBy(options, 'value')
    if (sortList !== '') {
      options = _.sortBy(options, (val) => val.value)
      if (sortList === 'DESC') {
        options = _.reverse(options)
      }
    }
    return options
  }, [id, preFilteredRows, colFilter, rows, sortList])

  // Render a multi-select box
  return (
    <Autocomplete
      options={options}
      getOptionLabel={(v) => v.label}
      value={getValue(options, filterValue)}
      fullWidth
      onChange={(event, value) => {
        setFilter(value?.value || undefined)
        setFilterCols({
          ...colFilter.toJS(),
          [id]: value?.value,
        })
        if (value?.value) {
          setPage(0)
        }
      }}
      classes={{
        paper: clsx(
          `ft--theme--Prjft--${uid}--root--menu ft--theme--PrjPowerTableFilterField--root--menu`,
          `ft--theme--Prjft--${uid}--picklist--menu`
        ),
        option: clsx(
          `ft--theme--Prjft--${uid}--select ft--theme--PrjPowerTableFilterField--select ft--theme--PrjPowerTableFilterField--picklist--option ft--theme--PrjPowerTableFilterField--picklist--optionselect`,
          `ft--theme--Prjft--${uid}--root ft--theme--PrjPowerTableFilterField--root`,
          `ft--theme--Prjft--${uid}--root--option ft--theme--PrjPowerTableFilterField--root--option`,
          `ft--theme--Prjft--${uid}--picklist--option ft--theme--Prjft--${uid}--picklist--optionselect`
        ),
        listbox: `ft--theme--Prjft--${uid}--scroll ft--theme--PrjPowerTableFilterField--scroll`,
        inputRoot: 'inputRoot',
        endAdornment: 'ft--theme--FormField--endado',
        clearIndicator: clsx(
          `ft--theme--PrjPowerTableFilterField--endIcon`,
          `ft--theme--Prjft--${uid}--endIcon`,
          'ftclear'
        ),
      }}
      className={clsx(
        `ft--theme--PrjPowerTableFilterField-container`,
        `ft--theme--PrjPowerTableFilterField--select`,
        `ft--theme--PrjPowerTableFilterField--${variant}`,
        `ft--theme--PowerTableFilterField-container`,
        `ft--theme--PowerTableFilterField--select`,
        `ft--theme--PowerTableFilterField--${variant}`,
        `ft--theme--Prjft--${uid}--select`,
        `ft--theme--Prjft--${uid}--${variant}`,
        `ft--theme--PrjPowerTableFilterField--size-${size}`,
        'ft--theme--PrjPowerTableFilterField--selectField',
        `ft--theme--PowerTableFilterField--size-${size}`,
        'ft--theme--PowerTableFilterField--selectField',
        containerClass
      )}
      renderInput={({ InputProps, ...params }) => (
        <TextField
          {...params}
          FormHelperTextProps={{
            className: 'ft-helper-txt',
          }}
          InputLabelProps={{
            classes: {
              root: `ft--label`,
              shrink: 'ft--shrink',
              focused: 'ftfocused',
            },
          }}
          variant={variant}
          size={size}
          InputProps={{
            ...InputProps,
            classes: {
              root: 'ft--theme--PowerTableFilterField-elRoot ft--theme--PrjPowerTableFilterField-elRoot',
              focused: 'ftfocused',
              ...(variant === 'outlined' ? { notchedOutline: 'ftnotchedOutline' + notchedOutlineClass } : {}),
            },
          }}
        />
      )}
    />
  )
}
